import { Component, Prop, h, Host } from '@stencil/core';

const COMPONENT_NAME = 'sn-how-it-works-type-2';

/**
 * "How it works" section for SignNow forms pages. Displays a section heading
 * and up to three step cards arranged horizontally on desktop and stacked on mobile.
 * Each card shows an illustration, a bold step title, and a short description.
 * Data is sourced from the `hiw` backend data block.
 *
 * @product signnow
 * @source hiw
 * @version 2.0.0
 * @category SignNow
 * @slot heading - <me-heading variant="4" tag=["h1", "h2", "h3", "h4", "h5", "h6", "div"]> - Section heading (inline editable)
 * @slot items - {required}, {multiple}, {min-items: 1}, {max-items: 3}, <li class="sn-how-it-works-type-2__item"> - Step items with images and text
 * @example
 *   <sn-how-it-works-type-2>
 *     <me-heading slot="heading" variant="4" tag="h2">How it works</me-heading>
 *     <li slot="items" class="sn-how-it-works-type-2__item">
 *       <div class="sn-how-it-works-type-2__image-wrapper">
 *         <img src="https://marketing-static.signnow.com/366/images/forms/bitmap/open-form-icon@2x.png" alt="" class="sn-how-it-works-type-2__image" loading="lazy" width="80" height="80" />
 *       </div>
 *       <p class="sn-how-it-works-type-2__content">
 *         <strong class="sn-how-it-works-type-2__title">Open form</strong>
 *         <span class="sn-how-it-works-type-2__description">follow the instructions</span>
 *       </p>
 *     </li>
 *   </sn-how-it-works-type-2>
 */
@Component({
  tag: 'sn-how-it-works-type-2',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SnHowItWorksType2 {
  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';

  render() {
    return (
      <Host data-color-mode={this.colorMode}>
        <section class={COMPONENT_NAME}>
          <div class={`${COMPONENT_NAME}__container`}>
            <slot name="heading"></slot>
            <ul class={`${COMPONENT_NAME}__list`}>
              <slot name="items"></slot>
            </ul>
          </div>
        </section>
      </Host>
    );
  }
}
